import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid/models';
import CopyText from 'src/components/copyText/CopyText';
import { getEllipsisTxt } from 'src/utils/formatters';

interface Props {
    val: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>;
    tradeStatus?: String;
}

export default function RenderCopy({ val }: Props) {
    return (
        <CopyText textProps={{ variant: 'body1' }} toCopy={val.value}>
            {getEllipsisTxt(val.value === undefined || val.value === '' ? '--' : val.value, 50)}
        </CopyText>
    );
}
